import { createContext, useContext } from "react";
var configContext = createContext(undefined);
export var ConfigProvider = configContext.Provider;
export var useConfig = function () {
    var value = useContext(configContext);
    if (!value) {
        throw new Error("No config");
    }
    return value;
};
export default configContext;
//# sourceMappingURL=useConfig.js.map